import axios from 'axios';
import { msalInstance } from './authConfig';

// Use the configured VITE_API_BASE_URL if available, otherwise default to empty string (relative path)
const baseURL = import.meta.env.VITE_API_BASE_URL || '';


export const api = axios.create({
  baseURL,
  withCredentials: false, // We'll handle credentials manually
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  async (config) => {
    try {
      // Get the active account from MSAL
      const account = msalInstance.getActiveAccount();

      if (account) {
        try {
          // First try to get token silently
          const response = await msalInstance.acquireTokenSilent({
            account,
            scopes: ["User.Read"],
          });

          if (response && response.accessToken) {
            config.headers.Authorization = `Bearer ${response.accessToken}`;
          } else {
            console.warn('No access token received');
          }
        } catch (error) {
          console.warn('Silent token acquisition failed, trying interactive', error);
          // Don't try interactive here as it would cause redirect loops
          // The user will need to sign in again
          throw error;
          // If silent acquisition fails, try interactive
          const response = await msalInstance.acquireTokenPopup({
            scopes: ["User.Read"],
          });

          if (response && response.accessToken) {
            config.headers.Authorization = `Bearer ${response.accessToken}`;
          }
        }
      } else {
        // If no account is found, redirect to login
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
        return Promise.reject(new Error('No active account'));
      }

      return config;
    } catch (error) {
      console.error('Error getting access token:', error);
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't tried to refresh the token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to get a new token
        const account = msalInstance.getActiveAccount();
        if (account) {
          const response = await msalInstance.acquireTokenSilent({
            account,
            scopes: ["api://8d41e9b8-8194-440a-a349-cef9269ed564/.default"],
            forceRefresh: true // Force token refresh
          });

          if (response && response.accessToken) {
            // Update the Authorization header
            originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
            // Retry the original request with the new token
            return api(originalRequest);
          }
        }
      } catch (error) {
        console.error('Error refreshing token:', error);
        // If we can't refresh the token, redirect to login
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
